import React, { useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import { useHistory } from "react-router-dom";
import auth from "../../../core/auth";
import { useCookies } from "react-cookie";
import { useAlert } from "react-alert";
import { encode as base64_encode } from "base-64";
import { Redirect } from "react-router-dom";
import "react-confirm-alert/src/react-confirm-alert.css";
import { confirmAlert } from "react-confirm-alert";
import mqtt_topics from "../../../mqtt/mqtt_topics";
const mqtt = require("../../../mqtt/mqtt.js");
const appparameters = require("../../../core/common.jsx");

export default function Login(props) {
  const history = useHistory();
  const alert = useAlert();
  const [username, setUserName] = useStateIfMounted("");
  const [password, setPassword] = useStateIfMounted("");
  const [valid, setIsValid] = useStateIfMounted(false);
  const [loading, setLoading] = useStateIfMounted(false);

  //lifecycle methods
  useEffect(() => {
    //componentDidMount || componentDidUpdate
    //console.log("use effect executed!");
  });

  useEffect(() => {
    const savedtoken = localStorage.getItem("token");
    const savedusername = localStorage.getItem("username");
    if (savedtoken && savedusername) {
      setLoading(true);
      //console.log("backend_app_url:" + appparameters.backend_app_url);
      fetch(appparameters.backend_app_url + "/frontend/login", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user: {
            username: savedusername,
            token: savedtoken,
          },
        }),
      }) /*.then((response) => {
        if (!response.ok) {
            // error processing
            throw 'Error';
        }
        return response.json()
    })*/
        .then((res) => res.json())
        .then((response) => {
          //console.log("request result from login ");
          //console.log(response);
          if (response.result) {
            auth.login(true, response.data); //console.log("returned true login");
            localStorage.setItem("token", response.data.token);
            localStorage.setItem("username", response.data.username);
            setIsValid(true);
          } else {
            clearlogindata();
            auth.login(false, {});
          }
          //setLoading(false);
        })
        .catch((err) => setLoading(false));
    }
  }, []);

  const submitlogin = (e) => {
    e.preventDefault();

    if (!username || !password) {
      alert.show("Fill all fields", { type: "error" });
      return;
    }
    setLoading(true);
    fetch(appparameters.backend_app_url + "/frontend/login", {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        user: {
          username: username,
          password: base64_encode(password),
        },
      }),
    })
      .then((res) => res.json())
      .then((response) => {
        //console.log("request result from login ");
        //console.log(response);
        if (response.result) {
          auth.login(true, response.data); //console.log(response.data);
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("username", response.data.username);
          setIsValid(true);
        } else {
          clearlogindata();
          let alertstatment;
          if (response.error == "") {
            alertstatment = "Failed to login";
          } else {
            alertstatment = "Failed to login, " + response.error;
          }
          alert.show(alertstatment, { type: "error", position: "middle" });
          auth.login(false, {});
        }
        //setLoading(false);
      });
  };

  function clearlogindata() {
    setUserName("");
    setPassword("");
    setIsValid(false);
    setLoading(false);
  }

  const options = {
    customUI: ({ onClose }) => {
      return (
        <div className="alert">
          <h1 className="alert__title">Reset account password</h1>
          <p className="alert__body">Proceed ?</p>
          <button
            onClick={() => {
              resetpassword();
              onClose();
            }}
            className="btn btn-primary"
          >
            Yes
          </button>
          &nbsp;
          <button className="btn btn-secondary" onClick={onClose}>
            No
          </button>
        </div>
      );
    },
  };

  function resetpassword() {
    if (username == "" || username == undefined) {
      alert.show("Empty username field", { type: "error", position: "middle" });
    } else {
      fetch(appparameters.backend_app_url + "/frontend/forgetpass", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username: username,
        }),
      })
        .then((res) => res.json()) //.json()
        .then((response) => {
          //console.log("request result from login ");
          //console.log(response);
          if (response) {
            alert.show("Check your registered email to proceed", {
              type: "success",
            });
          } else {
            alert.show("Failed request", { type: "error", position: "middle" });
          }
        });
    }
  }
  useEffect(() => {
    window.onbeforeunload = (e) => {
      // I'm about to refresh! do something...
      if (mqtt_topics.mqttclientinstance.connected) {
        mqtt_topics.mqttclientinstance.end();
      }
    };
  }, []);

  if (valid) {
    if (
      mqtt_topics.mqttclientinstance == undefined ||
      !mqtt_topics.mqttclientinstance.connected
    ) {
      mqtt_topics.mqttclientinstance = mqtt.connect();
      mqtt_topics.mqttclientinstance.setMaxListeners(0);
    }
    return <Redirect to={"/grid"} />;
  } else if (loading) {
    return (
      <div className="container">
        <center>
          <img
            src={require("./../../../images/simpleloading.gif")}
            className="simpleloadingview"
          />
          <p>
            <strong>Loading ...</strong>
            <br />
          </p>
        </center>
      </div>
    );
  } else {
    return (
      <React.Fragment>
        <div className="loginrow mainimagebackground">
          <div className="login">
            <h1>&nbsp;</h1>
            <form onSubmit={submitlogin}>
              <input
                type="text"
                placeholder="Username"
                required="required"
                value={username}
                onChange={(e) => setUserName(e.target.value)}
              />
              <input
                type="password"
                placeholder="Password"
                required="required"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <p>&nbsp;</p>
              <button
                type="submit"
                className="loginbtn btn-primary btn-block btn-large"
              >
                Login
              </button>
            </form>
            <br></br>
            <center>
              <button
                type="button"
                className="btn btn-warning btn-sm"
                align="center"
                onClick={() => history.push("/Add-Account")}
              >
                &nbsp;Register&nbsp;
              </button>
              &nbsp;
              <button
                type="button"
                className="btn btn-warning btn-sm"
                align="center"
                onClick={() => confirmAlert(options)}
              >
                Reset ?
              </button>
            </center>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
